module.exports = __webpack_public_path__ + "static/media/DATA5-popup.99565f40.jpg";